
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Le changement de cap de la politique climatique n'a pas porté ses fruits pour le PLR. Sa présidente, Petra Gössi, estime que le PLR est parvenu à limiter les dégâts. Son parti réunit toujours 15,3% de l'électorat. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;